import { GuestWaitingList } from '@seaters/constants';
import {
  addToCalendar as addToCalendarShared,
  isMobile,
  isSafari,
} from '@seaters/ui-shared';

type UseAddToCalendarProps = {
  waitingListData: GuestWaitingList;
};

export const useAddToCalendar = ({
  waitingListData,
}: UseAddToCalendarProps) => {
  const addToCalendar = () => {
    if (isMobile()) {
      triggerCalendar(isSafari() ? 'apple' : 'google');
      return;
    }

    triggerCalendar('apple');
    triggerCalendar('google');
  };

  const triggerCalendar = (platform: 'apple' | 'google' | 'outlook') => {
    addToCalendarShared({
      waitingList: waitingListData,
      platform,
    });
  };

  const openAppleCalendar = () => {
    triggerCalendar('apple');
  };

  const openGoogleCalendar = () => {
    triggerCalendar('google');
  };

  const openOutlookCalendar = () => {
    triggerCalendar('outlook');
  };

  return {
    addToCalendar,
    openAppleCalendar,
    openGoogleCalendar,
    openOutlookCalendar,
  };
};
